module.exports = __webpack_public_path__ + "assets/img/trust_8.ffd71456.png";